import { db, firebase } from '@/shared/firebase/firebase-init';
import _ from 'underscore'
import logService from '@/shared/entity-logger';
import managerModel from './field-manager-model';

/* eslint-disable */
const KEY_FIELD_MANAGERS="fieldManagers"
const NAME_ENTITY= 'field-manager'

export default {
  list() {
    return new Promise((resolve) => {
      db.ref(KEY_FIELD_MANAGERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_FIELD_MANAGERS).child(id).once('value').then((snapshot) => { 
        const model = snapshot.val();
        
        if (!model) {
          reject("Empy manager-model");
        }
        resolve(model)
      })
    });      
  },

  findByEmail(email) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_FIELD_MANAGERS).orderByChild("email").equalTo(email).once('value').then((snapshot) => { 
        var model = {}
        snapshot.forEach((it) => {
           model = it.val();  
        })
        
        if (!model == null || _.isEmpty(model)) {
          reject("User manager no exist");
        }
        
        resolve(model)
      })
    });      
  },

  destroy(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_FIELD_MANAGERS).child(id).set(null, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          resolve()
        }
      })
    })
  },

  update(model, loggedUser) {
    const modelToUpdate = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: {id: loggedUser.id, email: loggedUser.email}
    };

    console.log("<--- update");
    console.log(modelToUpdate);
    
    return new Promise((resolve, reject) => {
          db.ref(KEY_FIELD_MANAGERS).child(modelToUpdate.id).set(managerModel.forUpdate(modelToUpdate), (error) => {
            if (error) {
              // The write failed...
              reject(error)
            } else {
              // Data saved successfully!
              logService.log(modelToUpdate, "modified", KEY_FIELD_MANAGERS, NAME_ENTITY)
              resolve()
            }
          })
      });
  },

  create(model, loggedUser) {

    const modelToSave = {
      ...model,
      id: db.ref(KEY_FIELD_MANAGERS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      createdBy: {id: loggedUser.id, email: loggedUser.email} ,
      modifiedBy: {id: loggedUser.id, email: loggedUser.email}
    };

    console.log("<--- create");
    console.log(modelToSave);

    return new Promise((resolve, reject) => {
        db.ref(KEY_FIELD_MANAGERS).child(modelToSave.id).set(managerModel.forCreate(modelToSave), (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            logService.log(modelToSave, "created", KEY_FIELD_MANAGERS, NAME_ENTITY)
            resolve()
          }
        });
     
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_FIELD_MANAGERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          const modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.label = childSnapshot.val().name
          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/field-manager/field-manager-service.js